import { Input } from 'ccs-ui-components';
import { Col, Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { IServiceDetailsValidationModel } from '../../../../../models';
import { getServiceEndPointPlaceholder } from '../../../../../utilities/services/LabelUtils';
import { ServiceVariableTooltip } from '../../../../../utilities/services/ServiceVariableTooltip';

interface IAuthUrlProps {
  isEdit: boolean;
  formData: IServiceDetailsValidationModel;
  handleInputChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  serviceTypeValue: string | undefined

}
const AuthUrl = ({
  isEdit,
  formData,
  handleInputChange,
  serviceTypeValue
}: IAuthUrlProps) => {
  const { t: translate } = useTranslation();
  return (
    <Col md={6}>
      <Form.Group className="mb-3" controlId="authUrl">
        <Input
          isMandatory
          labelText={String(translate('service_details_form_component.lbl_auth_url'))}
          infoIconTxt={<ServiceVariableTooltip />}
          label=""
          placeholder={
            isEdit
              ? String(getServiceEndPointPlaceholder(serviceTypeValue ?? '0', translate))
              : ''
          }
          name="authUrl"
          onChange={handleInputChange}
          value={formData.authUrl.value}
          error={!formData.authUrl.isValid && isEdit}
          data-testid="authUrl"
          errorTxt={isEdit ? formData.authUrl.error : ''}
          maxLength={Number.MAX_SAFE_INTEGER}
        />
      </Form.Group>
    </Col>
  );
};

export default AuthUrl;
